(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.csmDetails = definition();

    }

    function definition() {

        return {
            'Mark Pearson': {
                alias: 'inquire',
                pronouns: 'he/him',
                title: 'Account Executive'
            },
            'Cat Martinez': {
                alias: 'support',
                pronouns: 'she/her',
                title: 'Customer Success Manager'
            },
            'Matt Gerrish': {
                alias: 'support',
                pronouns: 'he/him',
                title: 'Customer Success Manager'
            },
            'Pykasu Koube': {
                alias: 'support',
                pronouns: '', // NOTE intentionally left blank
                title: 'Customer Success Manager'
            },
            'Melissa Wrzesniewsky': {
                alias: 'support',
                pronouns: '',
                title: 'Account Manager'
            }
        };
    }
})();
